import React, { useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import ButtonLink from 'components/button-link';
import { TGame } from 'types';
import './styles.scss';

interface IAboutGame {
  game: TGame;
}

const LINE_HEIGHT = 21;

const AboutGame: React.FC<IAboutGame> = ({ game }) => {
  const { t } = useTranslation();
  const descriptionRef = useRef<HTMLDivElement>(null);
  const moreBtnRef = useRef<HTMLButtonElement>(null);

  useLayoutEffect(() => {
    const descriptionHeight = descriptionRef.current?.scrollHeight || 0;

    // We should show 'more' button if the description has more than 3 lines.
    if (descriptionHeight > (LINE_HEIGHT * 3) && moreBtnRef.current) {
      moreBtnRef.current.style.display = 'block';
    }
  }, []);

  const handleMoreBtnClick = () => {
    if (moreBtnRef.current && descriptionRef.current) {
      moreBtnRef.current.style.display = 'none';
      descriptionRef.current.classList.add('pre-wrap');
      descriptionRef.current.style.maxHeight = 'unset';
    }
  };

  return (
    <div className="flex flex-col mb2 p-side">
      <p className="heading">{t('aboutGame')}</p>
      <div className="about-game flex flex-col">
        <div className="description" ref={descriptionRef}>{game.description}</div>
        <ButtonLink className="more-btn" innerRef={moreBtnRef} onClick={handleMoreBtnClick}>
          {t('moreButton')}
        </ButtonLink>
      </div>
    </div>
  );
};

export default AboutGame;
